// Safari, in Private Browsing Mode, doesn't fully support sessionStorage / localStorage
// and throw QuotaExceededErrors: DOM Exception 22
// Those exceptions will be caught
//
// For Safari Private Browsing Mode and our testing environment, a fallback storage will be used :
// Localstorage will be replaced by CookieStorage
// SessionStorage will be bypassed

interface WebStorage {
  setItem: (item: string, value: unknown) => void;
  getItem: (item: string) => string | undefined;
}

function writeCookie(name: string, value: unknown, days: number): void {
  if (document) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
  }
}

function readCookie(name: string): string {
  if (document) {
    const nameEq = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEq) === 0) {
        return c.substring(nameEq.length, c.length);
      }
    }
  }
  return '';
}

function fallbackStorage(storage?: string): WebStorage {
  if (storage === 'localStorage') {
    return {
      setItem: (item, value) => writeCookie(item, value, 365),
      getItem: (item) => readCookie(item),
    };
  }
  return {
    setItem: (): void => {
      // nothing
    },
    getItem: (): undefined => undefined,
  };
}

export const getStorage = (storage: string): WebStorage => {
  if (typeof (window as any)[storage] === 'object') {
    try {
      (window as any)[storage].setItem('storageTest', 1);
      (window as any)[storage].removeItem('storageTest');
    } catch (e) {
      return fallbackStorage(storage);
    }
  }
  return (window as any)[storage] || fallbackStorage();
};

export const sessionStorage = (): WebStorage => getStorage('sessionStorage');
export const localStorage = (): WebStorage => getStorage('localStorage');

export default {
  sessionStorage,
  localStorage,
};
